import * as authEvents from "../../store/events/auth";
import * as profileEvents from "../../store/events/profile";
import Box from "@mui/material/Box";
import Button from "../Button/Button";
import DOMPurify from "dompurify";
import ProfileErrorMessages from "../ErrorMessages/ProfileErrorMessages";
import React from "react";
import { TERMS_OF_USE_CURRENT_VERSION } from "../../config/common";
import Typography from "@mui/material/Typography";
import { connect } from "react-redux";
import { Form, isStringOfLength } from "@pheaa/channels-component-library";

const TermsOfUseForm = props => {

	let actionText = null;
	let contentElem = null;

	const {
		endSession,
		isAgreeingTerms,
		isPendingSessionEnd,
		submitTermsAgreement
	} = props;

	const [termsContent, setTermsContent] = React.useState({
		html: null,
		isError: false,
		isFetching: false
	});

	const fetchTermsContent = () => {

		setTermsContent(current => ({ ...current, isFetching: true }));

		fetch(`${process.env.PUBLIC_URL}/assets/IAM/terms-and-conditions.html`).then(async response => {
			const body = await response.text();
			setTermsContent(current => ({ ...current, isError: false, html: body }));
		}).catch(error => {
			setTermsContent(current => ({ ...current, isError: true }));
		}).finally(() => {
			setTermsContent(current => ({ ...current, isFetching: false }));
		});
	};

	const handleSubmit = (e, formData) => {
		if (termsContent.isError) {
			fetchTermsContent();
		} else {
			submitTermsAgreement(formData);
		}
	};

	React.useEffect(() => {
		!termsContent.isFetching && fetchTermsContent();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (termsContent.isError) {
		actionText = "Try Again";
		contentElem = <div>An error occurred while loading the Terms and Conditions.</div>;
	} else if (termsContent.isFetching) {
		actionText = "Loading...";
		contentElem = <div>Loading Terms and Conditions...</div>;
	} else if (isStringOfLength(termsContent.html)) {
		actionText = "Accept";
		contentElem = <div className="cmp-terms__content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(termsContent.html) }} />;
	} else {
		actionText = "Unexpected Error";
		contentElem = <div>Terms and Conditions unavailable.</div>;
	}

	return (
		<React.Fragment>
			<Typography
				component="h1"
				gutterBottom={true}
				variant="h3"
			>
				Terms of Service
			</Typography>
			<Form
				id="defaultFormNarrow"
				onSubmit={handleSubmit}
			>
				<ProfileErrorMessages />
				<Typography
					className="cmp-terms"
					component="div"
					sx={{
						fontSize: 12,
						marginTop: 1.5
					}}
				>
					{contentElem}
				</Typography>
				<Box
					mb={1.75}
					mt={5.625}
				>
					<input
						name="agreementVersion"
						type="hidden"
						value={TERMS_OF_USE_CURRENT_VERSION}
					/>
					<Button
						disabled={isAgreeingTerms || termsContent.isFetching || !isStringOfLength(termsContent.html) || isPendingSessionEnd}
						processing={isAgreeingTerms || termsContent.isFetching}
						type="submit"
						variant="contained"
					>
						{actionText}
					</Button>
					<Box mt={1.75}>
						<Button
							disabled={isPendingSessionEnd}
							onClick={() => { endSession(); }}
							processing={isPendingSessionEnd}
							size="small"
						>
							Sign Out
						</Button>
					</Box>
				</Box>
			</Form>
		</React.Fragment>
	);
};

const mapStateToProps = state => ({
	isAgreeingTerms: state.profile.isAgreeingTerms,
	isPendingSessionEnd: state.auth.isPendingSessionEnd
});

const mapDispatchToProps = dispatch => ({
	endSession: data => dispatch(authEvents.endSession(data)),
	submitTermsAgreement: data => dispatch(profileEvents.submitTermsAgreement(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(TermsOfUseForm);